import styled from "styled-components";
import { EVIAN_COLORS } from "../../utils/Colors";

const radii = {
    md: "10px",
    lg: "14px",
    xl: "18px",
};

const Note = styled.aside`
  margin-top: 18px;
  background: ${EVIAN_COLORS.primary};
  border: 1px solid ${EVIAN_COLORS.primaryHover};
  border-radius: ${radii.md};
  padding: 14px 14px;
  display: grid;
  grid-template-columns: 26px 1fr;
  gap: 10px;
  align-items: start;
`;

const Leaf = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
`;

const NoteContent = styled.div`
  display: grid;
  gap: 6px;

  strong {
    color: ${EVIAN_COLORS.panel};
    font-weight: 700;
  }

  p {
    color: ${EVIAN_COLORS.panel};
    font-size: 14px;
    line-height: 1.45;
  }
`;

const Footnote = styled.p`
  margin-top: 18px;
  text-align: center;
  color: ${EVIAN_COLORS.muted};
  font-size: 12px;
`;

export const EvianRegisterFootnote = () => {
    return (
        <>
            <Note role="note" aria-label="Sustainability Note">
                <Leaf>🍃</Leaf>
                <NoteContent>
                    <strong>Sustainability Note</strong>
                    <p>
                        This exclusive sweepstakes is unlocked only through recycling at the Olyns Cube at
                        the 2025 evian F1 activation in Las Vegas, supporting evian&apos;s mission for a circular
                        future.
                    </p>
                </NoteContent>
            </Note>
            <Footnote>No purchase necessary. Sponsored by evian.</Footnote>
        </>
    );
};